import { render, staticRenderFns } from "./OrganisationUnitsImport.vue?vue&type=template&id=5cf58de2&"
import script from "./OrganisationUnitsImport.vue?vue&type=script&lang=ts&"
export * from "./OrganisationUnitsImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports